import React, { FunctionComponent, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../../shared/Button';
import { joinStrings } from '../../../utils/string';
import { setProductTab } from '../../../state/promotions/reducers';
import { PromoTab } from '../types';
import { useTranslations } from '../../../hooks/useTranslationsHelper';
import { productTabName } from '../../../state/promotions';
import './styles';
import { ProductType } from '../../Layout/Promotions/PromotionsBlock/types';

type ProductTabsProps = {
  promotionTabs: PromoTab[];
  className?: string;
  isEnabledProductCasino: boolean;
  isEnabledProductSports: boolean;
  isSportProductTab: boolean;
  filterCategoryToProduct: (productName: ProductType) => void;
};
type ArrProductTabsProps = {
  type: string;
  active: boolean;
  enabled: boolean;
  productName: ProductType;
};

export const ProductTabs: FunctionComponent<ProductTabsProps> = ({
  promotionTabs,
  isEnabledProductCasino,
  isSportProductTab,
}) => {
  const { t } = useTranslations();
  const dispatch = useDispatch();
  const currentProductTabName = useSelector(productTabName);

  const productTabs: ArrProductTabsProps[] = useMemo(() => {
    return promotionTabs.map((promoTab) => ({
      type: promoTab.id,
      active: currentProductTabName === promoTab.id,
      enabled: isEnabledProductCasino,
      productName: promoTab.id,
    }));
  }, [isEnabledProductCasino, isSportProductTab, promotionTabs, currentProductTabName]);

  const getPromoTabName = (productTab: ArrProductTabsProps): string =>
    productTab.type === ProductType.PROMOTIONS
      ? t('promotions.page.title.default')
      : t('promotions.page.title.logged-in');

  return (
    <div className="product-tabs">
      {productTabs
        .filter(({ enabled }) => enabled)
        .map((productTab, index) => {
          return (
            <Button
              type="button"
              key={`${productTab.type}-${index}`}
              variant="text-alt"
              className={joinStrings([productTab.active && 'product-tabs--active'])}
              onClick={(): void => {
                dispatch(setProductTab(productTab.productName));
              }}
            >
              {getPromoTabName(productTab)}
            </Button>
          );
        })}
    </div>
  );
};
